class Boutique
{
    constructor(params = {})
    {
        this.debug = "no";
        this.aData = [];

        if( params["debug"] )
        {
            this.debug = params["debug"];
        }
    }

    getPreviewCriterias(params)
    {
        params.f = "xml";
        params.a = this.constructor.name.toLowerCase();
        params.p = "criterias_preview";
        sendAjaxRequest(this, params);
    }
}